<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1138 1031"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1046.1 1025.54H1046.1H1136.5V962.604V892.8V708.663V524.526V339.186V155.049V60.1452L1090.31 1.5H1.5V67.1317V133.263V888.267V971.988L47.6853 1029.5L1046.1 1025.54Z"
            stroke="#00B058"
          />
          <path
            d="M105.504 1026.32H48.7663L4.87042 972.534V911.729"
            stroke="#00B058"
            stroke-width="9"
          />
          <path
            d="M1032.5 4.67732H1089.23L1133.13 58.466V119.271"
            stroke="#00B058"
            stroke-width="9"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="55"
          >
            <div>
              <b-img
                height="60"
                src="@/assets/images/icons/bridge/Bridgeicon.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="25"
            y="202"
            width="100%"
            height="90%"
          >
            <div>
              <div v-if="img">
                <!-- <span class="text1">ภาพการวิเคราะห์จราจรล่าสุด</span> -->
                <b-img
                  :src="img"
                  style="width:95%; height:auto; flex-direction: row;"
                />
              </div>
              <div
                v-else
                style="margin-right: 80px;"
              >
                <center>
                  <img
                    height="790px"
                    src="@/assets/images/icons/markeranalytic120/Noimage.svg"
                  >
                </center>
              </div>
            </div>
          </foreignObject>
          <foreignObject
            v-if="camid"
            x="120"
            y="60"
            width="100%"
            height="90%"
          >
            <div>
              <h1 style="font-size: 48px;">ภาพเรือที่มีความสูงเกินกำหนดล่าสุด (กล้อง {{ camid }})</h1>
            </div>
          </foreignObject>
          <foreignObject
            v-else
            x="120"
            y="60"
            width="100%"
            height="90%"
          >
            <div>
              <h1 style="font-size: 48px;">ภาพเรือที่มีความสูงเกินกำหนดล่าสุด</h1>
            </div>
          </foreignObject>
          <foreignObject
            v-if="camdesc"
            x="0"
            y="876"
            width="100%"
            height="90%"
          >
            <div>
              <!-- <h1 class="text2 mt-1">จุดติดตั้ง: {{ camdesc }}</h1> -->
              <h1 class="text3 mt-1">{{ date }} ({{ detection }})</h1>
            </div>
          </foreignObject>
          <foreignObject
            v-else
            x="0"
            y="626"
            width="100%"
            height="90%"
          >
            <div />
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      img: '',
      camid: '',
      camdesc: '',
      detection: '',
      date: '',
      anydesk: '',
      live: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    // this.getMarkerAnalytic()
    this.getBoatLastImg()
    // this.getCamAnalytic()
    // this.getWayAnalytic()
    this.getEventImgAnalytic()

    this.interval = setInterval(() => {
      this.getCamAnalytic()
      this.getEventImgAnalytic()
    }, 300000)
  },
  methods: {
    getBoatLastImg() {
      axios
        .post('/imgBoatDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.img = response.data[0].FilePath
        })
        .catch(error => {
          console.log(error)
        })
    },
    getEventImgAnalytic() {
      axios
        .post('/getEventImgAIDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.camid = response.data[0].CAMID
          this.camdesc = response.data[0].Camera_Desc
          this.detection = response.data[0].Detection_Type
          this.date = response.data[0].DATE_TIME
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
.text1 {
font-size: 44px;
color: #ffffff;
// font-weight: bold;
}
.text2 {
font-size: 34px;
color: #ffffff;
text-align: center;
// font-weight: bold;
}
.text3 {
font-size: 40px;
color: #ffffff;
text-align: center;
// font-weight: bold;
}

</style>
